import api from '../../../shared/utils/api.js'
import {
  getAllReportsRequest,
  getAllReportsSuccess,
  getAllReportsFail,
  getReportDetailsRequest,
  getReportDetailsSuccess,
  getReportDetailsFail,
  sendAdminResponseRequest,
  sendAdminResponseSuccess,
  sendAdminResponseFail,
  deleteReportRequest,
  deleteReportSuccess,
  deleteReportFail,
} from '../../../state/redux/slices/reportsSlice.js'

export const getAllReports = (params = {}) => async dispatch => {
  try {
    dispatch(getAllReportsRequest())
    
    const queryString = new URLSearchParams(params).toString()
    const url = `/v1/reports/all${queryString ? `?${queryString}` : ''}`
    
    const response = await api.get(url)
    dispatch(getAllReportsSuccess(response.data.data))
  } catch (error) {
    dispatch(getAllReportsFail(error.response?.data?.message || error.message))
  }
}

export const getReportDetails = reportId => async dispatch => {
  try {
    dispatch(getReportDetailsRequest())
    const response = await api.get(`/v1/reports/${reportId}`)
    dispatch(getReportDetailsSuccess(response.data.data))
  } catch (error) {
    dispatch(getReportDetailsFail(error.response?.data?.message || error.message))
  }
}

export const sendAdminResponse = (reportId, responseData) => async dispatch => {
  try {
    dispatch(sendAdminResponseRequest())
    
    const requestData = {
      ...responseData,
      isResponded: Boolean(responseData.isResponded !== false)
    }
    
    console.log('Sending admin response:', requestData)
    
    const response = await api.patch(`/v1/reports/${reportId}/admin-response`, requestData)
    
    const responsePayload = {
      ...response.data.data || response.data,
      reportId
    }
    
    dispatch(sendAdminResponseSuccess(responsePayload))
  } catch (error) {
    console.error('Admin response error:', error.response?.data || error)
    const errorMessage = error.response?.data?.message || error.message || 'Failed to send admin response'
    dispatch(sendAdminResponseFail(errorMessage))
  }
}

export const deleteReport = reportId => async dispatch => {
  try {
    dispatch(deleteReportRequest())
    const response = await api.delete(`/v1/reports/${reportId}`)
    dispatch(deleteReportSuccess({ ...(response.data.data || response.data), reportId }))
  } catch (error) {
    dispatch(deleteReportFail(error.response?.data?.message || error.message))
  }
}